import { getFullUrl } from 'hubspot-url-utils';
import styled, { css } from 'styled-components';
import { usePortal, useTranslation } from '../../../hooks/useNavConfig';
import { MenuItem } from '../../Menu';
import { ButtonWithDemoExitConfirmation } from '../../DemoExitConfirmation/ButtonWithDemoExitConfirmation';
import { getAccountMenuBorder, getAccountMenuItemPadding } from '../shared-styles';
import { getTypographyStyles } from '../../../nav-ui-components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledMenuItem = styled(MenuItem)(({
  theme: _theme
}) => {
  const theme = _theme;
  return css(["list-style-type:none !important;a{color:", " !important;border-bottom:", " !important;padding:", " !important;display:block;}"], theme.color['text-primary-default'], getAccountMenuBorder(theme), getAccountMenuItemPadding(theme));
});
const HeaderContainer = styled.div.withConfig({
  displayName: "Progress__HeaderContainer",
  componentId: "sc-5z29ae-0"
})(["display:flex;flex-direction:row;justify-content:space-between;align-items:center;"]);
const HeaderText = styled.div.withConfig({
  displayName: "Progress__HeaderText",
  componentId: "sc-5z29ae-1"
})(({
  theme: _theme
}) => {
  const theme = _theme;
  return css(["color:", " !important;text-decoration:none;white-space:pre-wrap;word-wrap:break-word;", " margin-block:", " !important;", ":hover &{text-decoration:underline;}"], theme.color['text-primary-default'], getTypographyStyles(theme, 'heading-50'), theme.space['50'], StyledMenuItem);
});
const ProgressContainer = styled.div.withConfig({
  displayName: "Progress__ProgressContainer",
  componentId: "sc-5z29ae-2"
})(["display:flex;flex-direction:row;justify-content:space-between;"]);
const FullProgressBar = styled.div.withConfig({
  displayName: "Progress__FullProgressBar",
  componentId: "sc-5z29ae-3"
})(({
  theme: _theme
}) => {
  const theme = _theme;
  return {
    flex: 1,
    background: theme.color['fill-primary-disabled'],
    height: '15px',
    borderRadius: theme.borderRadius['100'],
    display: 'inline-block',
    margin: '5px 0 7px 0 !important',
    overflow: 'hidden',
    position: 'relative'
  };
});
const ProgressBarText = styled.div.withConfig({
  displayName: "Progress__ProgressBarText",
  componentId: "sc-5z29ae-4"
})(({
  theme: _theme
}) => {
  const theme = _theme;
  return css(["flex-shrink:0;text-decoration:none !important;", " color:", " !important;"], getTypographyStyles(theme, 'heading-50'), theme.color['text-primary-default']);
});
const CompletedProgressBar = styled.span.withConfig({
  displayName: "Progress__CompletedProgressBar",
  componentId: "sc-5z29ae-5"
})(({
  theme: _theme,
  progress
}) => {
  const theme = _theme;
  return {
    height: '15px',
    width: `${progress}%`,
    background: `linear-gradient(89deg, ${theme.color['fill-accent-green-default']}, ${theme.color['fill-accent-blue-default']})`,
    borderRadius: theme.borderRadius['100'],
    display: 'block',
    transition: 'width 0.6s ease'
  };
});
const Progress = ({
  progress,
  selectedView,
  groupKey,
  redirectToGrowthPlan,
  isPlpoEligible,
  plpoGroupKey,
  plpoProgress
}) => {
  const {
    t
  } = useTranslation();
  const {
    portalId
  } = usePortal();
  const href = redirectToGrowthPlan ? `${getFullUrl('app')}/growth-plan/${portalId}?via=account-menu` : `${getFullUrl('app')}/user-guide/${portalId}?via=account-menu`;
  const isPlpoRepGroupKey = plpoGroupKey.includes('rep');
  const plpoHref = isPlpoRepGroupKey ? `${getFullUrl('app')}/prospecting/${portalId}/onboarding?via=account-menu` : `${getFullUrl('app')}/global-home/${portalId}?via=account-menu`;
  return /*#__PURE__*/_jsxs(ButtonWithDemoExitConfirmation, {
    component: StyledMenuItem,
    href: isPlpoEligible ? plpoHref : href,
    id: "accountNavGettingStarted",
    "data-hub": selectedView,
    "data-group-key": groupKey,
    "data-test-id": "nav-account-onboarding",
    children: [/*#__PURE__*/_jsxs(HeaderContainer, {
      children: [/*#__PURE__*/_jsx(HeaderText, {
        children: redirectToGrowthPlan ? t('nav.gettingStarted.growthPlanHeader') : t('nav.gettingStarted.finishSetup')
      }), /*#__PURE__*/_jsx(ProgressBarText, {
        children: isPlpoEligible ? `${plpoProgress}%` : `${progress}%`
      })]
    }), /*#__PURE__*/_jsx(ProgressContainer, {
      children: /*#__PURE__*/_jsx(FullProgressBar, {
        children: /*#__PURE__*/_jsx(CompletedProgressBar, {
          progress: isPlpoEligible ? plpoProgress : progress
        })
      })
    })]
  });
};
export default Progress;